import axios, { AxiosResponse, AxiosError } from 'axios';
import { alertErrorMessage } from '../../utility/CustomAlertMessage';
import LoaderHelper from '../../utility/Loading/LoaderHelper';
import { ApiConfig } from './ApiEndpoints';

// Define types for parameters and headers
interface ApiHeaders {
  'Content-Type': string;
  Authorization?: string;
}


interface ApiResponse {
  data: any;
  message?: string;
}

interface ApiError extends AxiosError {
  response?: AxiosResponse<ApiResponse>;
}

const getToken = (): string | null => {
  const token = sessionStorage.getItem('STOCK_AUTH_TOKEN');
  return token ? `Bearer ${token}` : null;
};

export const ApiCallPost = async (
  url: string,
  parameters: any,
  headers: any
): Promise<any> => {
  try {
    let headers_: any = {
      'Content-Type': 'application/json',
      Authorization: getToken() || ''
    };
    const response: AxiosResponse<ApiResponse> = await axios.post(url, parameters, { headers: headers_ });
    LoaderHelper.loaderStatus(false);
    return response?.data;
  } catch (error) {
    LoaderHelper.loaderStatus(false);
    const apiError = error as ApiError;
    if (apiError?.response?.data?.message === 'Token is expired with message: res is not defined') {
      tokenExpire();
      return;
    } else {
      if (url === `${ApiConfig?.baseUrl}v1/exchange/historical-data`) {
        return apiError?.response?.data;
      }
      if (
        url === `${ApiConfig?.baseUrl}v1/user/login` ||
        url === `${ApiConfig?.baseUrl}v1/user/register`
      ) {
        alertErrorMessage(apiError?.response?.data?.message);
      } else {
        alertErrorMessage(apiError?.response?.data?.message);
      }
    }
  }
};

export const ApiCallGet = async (url: string, headers: any): Promise<any> => {
  try {
    let headers_:any  = {
      'Content-Type': 'application/json',
      Authorization: getToken() || ''
    };
    const response: AxiosResponse<ApiResponse> = await axios.get(url, { headers: headers_ });
    LoaderHelper.loaderStatus(false);
    return response?.data;
  } catch (error) {
    LoaderHelper.loaderStatus(false);
    const apiError = error as ApiError;
    if (apiError?.response?.data?.message === 'Token is expired with message: res is not defined') {
      tokenExpire();
      return;
    } else {
      alertErrorMessage(apiError?.response?.data?.message);
      return;
    }
  }
};

export const ApiCallPut = async (
  url: string,
  parameters: any,
  headers: any
): Promise<any> => {
  let headers_: any = {
    'Content-Type': 'application/json',
    Authorization: getToken() || ''
  };
  try {
    const response: AxiosResponse<ApiResponse> = await axios.put(url, parameters, { headers: headers_ });
    LoaderHelper.loaderStatus(false);
    return response?.data;
  } catch (error) {
    LoaderHelper.loaderStatus(false);
    const apiError = error as ApiError;
    if (apiError?.response?.data?.message === 'Token is expired with message: res is not defined') {
      tokenExpire();
      return;
    } else {
      alertErrorMessage(apiError?.response?.data?.message);
      return;
    }
  }
};

export const ApiCallDelete = async (url: string, headers: any): Promise<any> => {
  try {
    let headers_: any = {
      'Content-Type': 'application/json',
      Authorization: getToken() || ''
    };
    const response: AxiosResponse<ApiResponse> = await axios.delete(url, { headers: headers_ });
    LoaderHelper.loaderStatus(false);
    return response?.data;
  } catch (error) {
    LoaderHelper.loaderStatus(false);
    const apiError = error as ApiError;
    if (apiError?.response?.data?.message === 'Token is expired with message: res is not defined') {
      tokenExpire();
      return;
    } else {
      alertErrorMessage(apiError?.response?.data?.message);
      return;
    }
  }
};

const tokenExpire = (): void => {
  alertErrorMessage('Token is Expired');
  sessionStorage.clear();
  window.location.reload();
};